<template>
  <el-pagination 
    @size-change="handleSizeChange"
    @current-change="handleCurrentChange"
    :current-page="currentPage"
    :page-sizes="[10, 20, 30, 40]"
    :page-size="pageSize"
    layout="total, sizes, prev, pager, next, jumper"
    :total="total">
  </el-pagination>
</template>

<script setup>
// 定义props
const props = defineProps({
  currentPage: {
    type: Number,
    required: true,
    default: 1
  },
  pageSize: {
    type: Number,
    required: true,
    default: 10 
  },
  total: {
    type: Number,
    required: true,
    default: 0
  }
})

// 定义emit
const emit = defineEmits(['current-change', 'size-change'])

// 处理当前页码变化
const handleCurrentChange = (newCurrent) => {
  emit('current-change', newCurrent)
}

// 处理每页条数变化
const handleSizeChange = (newSize) => {
  emit('size-change', newSize)
}
</script>

<style scoped>
/* 保持原有分页组件的样式兼容性 */
:deep(.el-pagination) {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
  padding: 10px;
  background: #f5f7fa;
  border-radius: 4px;
}
</style>